const BRREG_EXPORT_COLUMNS = [
  ['orgnr', 'orgnr'],
  ['navn', 'name'],
  ['organisasjonsform', 'orgform'],
  ['status_brreg', 'status_brreg'],
  ['wash_status', 'wash_status'],
  ['ansvarlig', 'suggested_owner_id'],
  ['næringskode', 'naeringskode'],
  ['næringsbeskrivelse', 'naeringskode_desc'],
  ['adresse', 'address'],
  ['postnummer', 'postnr'],
  ['poststed', 'poststed'],
  ['kommune', 'kommune'],
  ['fylke', 'fylke'],
  ['nettside', 'website'],
  ['telefon', 'phone'],
  ['epost', 'email'],
  ['data_quality_score', 'data_quality_score'],
  ['job_id', 'job_id'],
  ['created_at', 'created_at']
];

const escapeCsvValue = value => {
  if (value === null || value === undefined) return '';

  const stringValue = String(value);
  const escapedValue = stringValue.replace(/"/g, '""');

  if (/[;"\r\n]/.test(escapedValue)) {
    return `"${escapedValue}"`;
  }

  return escapedValue;
};

export const buildBrregCsv = leads => {
  const header = BRREG_EXPORT_COLUMNS
    .map(([label]) => escapeCsvValue(label))
    .join(';');

  const rows = leads.map(lead => BRREG_EXPORT_COLUMNS
    .map(([, field]) => escapeCsvValue(lead?.[field]))
    .join(';'));

  return `\uFEFF${[header, ...rows].join('\r\n')}`;
};

export const downloadBrregCsv = (leads, date = new Date()) => {
  const csv = buildBrregCsv(leads);
  const dateString = date.toISOString().slice(0, 10);
  const filename = `brreg-leads-${dateString}.csv`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};